import { useEffect } from "react";
import environments from "../../../environment";
import Logger from "../../../utils/Logger";

declare var firebase: any;
const Log = Logger.getLogger("useFirebaseInit");

export default function useFirebaseInit() {
	useEffect(() => {
		if (!environments.firebaseConfig) return;
		try {
			firebase.initializeApp(environments.firebaseConfig);
			firebase.analytics();
			firebase.auth().useDeviceLanguage();
		} catch (e) {
			console.error("Firebase init error:", e);
		}
	}, []);
}
